import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  InlineStack,
  TextField,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const BackGround = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, BACKGROUND, DEFAULT_BACKGROUND_COLOR, DEFAULT_CONTENT_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.backgroundColor.title")}
        description={cms("section.backgroundColor.description")}
      >
        <Card
          title={[
            cms("section.backgroundColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.headerColor.title"), "TODO: ") }]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.backgroundColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.backgroundColor.label.hexCode")}
                    value={hex.backgroundHex}
                    onChange={(value) => handleChange(BACKGROUND, value, HEX)}
                    labelAction={
                      hex.backgroundHex !== DEFAULT_BACKGROUND_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(BACKGROUND, DEFAULT_BACKGROUND_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.background}
                  />
                  <br />
                  <Text>
                    <div
                      style={{
                        borderRadius: ".5rem",
                        width: "max-content",
                        height: "28px",
                        background: hex.backgroundHex,
                        color: DEFAULT_CONTENT_COLOR,
                        textAlign: "center",
                        padding: "6px 12px",
                      }}
                    >
                      {cms("section.backgroundColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(BACKGROUND, value, COLOR)} color={color.backgroundColor} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(BackGround);
